export default __webpack_public_path__ + "static/media/redGrid.caea7e2b.png";